import { isSzzaz, Szzaz } from "./szzaz";

export class Features {
    constructor(public companyId: number) {
    }

    get hasLargeScreenArea() {
        return !isSzzaz(this.companyId)
    }
    get hasDeviceSummaryChart() {
        return !isSzzaz(this.companyId)
    }
    get hasCustomDeviceSummaryDevice() {
        return isSzzaz(this.companyId)
    }
    get hasStresses() {
        return isSzzaz(this.companyId)
    }
    get hasOnlineDeviceCenterImage() {
        return !isSzzaz(this.companyId)
    }
    get hasCustomMappingText() {
        return !isSzzaz(this.companyId)
    }
}
